import staging from './actions/staging';

export default {
  staging,
};
